import { PaginationSize } from "@/common/enum/pagination-size";
import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { NoticeDetailDto } from "@/types/dto/notice-detail-dto";
import { TableHeader } from "@/types/table-header";
import { Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";
import { PartnerNoticeFooter } from "./PartnerNoticeFooter";
import { PartnerNoticeRow } from "./PartnerNoticeRow";

interface Props {
  page: BasePageDto<NoticeDetailDto>;
  selectedNotice: NoticeDetailDto | undefined;
  handleNoticeNameClick: (id: number) => void;
  handlePageChange: (currentPage: number) => void;
}

const headers: TableHeader[] = [
  { title: "No.", width: "w-[51px]" },
  { title: "공지사항 제목", width: "w-[591px]" },
  { title: "생성 날짜", width: "w-[118px]" },
];

export const PartnerNoticeTable: React.FC<Props> = ({
  page,
  selectedNotice,
  handleNoticeNameClick,
  handlePageChange,
}) => {
  const notices = page.contents;
  const totalElements = page.totalElements;
  const currentPage = page.currentPage;
  const startIndex = totalElements - (currentPage - 1) * PaginationSize.SIZE_12;

  return (
    <div className="overflow-x-auto rounded-lg border mr-[12px] h-fit">
      <Table>
        <Table.Head>
          {headers.map((header) => (
            <Table.HeadCell
              key={header.title}
              className={header.width + " h-[52px] p-0 border-b"}
            >
              <CustomCell>
                <Footnote12Description
                  className={"text-semantic-text-secondary"}
                >
                  {header.title}
                </Footnote12Description>
              </CustomCell>
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body className="divide-y">
          {notices.map((data, index) => (
            <PartnerNoticeRow
              key={data.id}
              data={data}
              index={startIndex - index}
              selectedNotice={selectedNotice}
              handleNoticeNameClick={handleNoticeNameClick}
            />
          ))}
          <PartnerNoticeFooter
            headersLength={Object.values(headers).length}
            page={page}
            handlePageChange={handlePageChange}
          />
        </Table.Body>
      </Table>
    </div>
  );
};
